//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { bootstrapApp } from '@motionelements/core/src/services/app.service';
import windowResizeMixin from '@motionelements/core/src/components/mixins/window-resize.mixin.js';
import productEventsMixin from '@motionelements/core/src/components/mixins/product-events.mixin.js';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
// import NavBar from '@motionelements/core/src/components/TheNavBar.vue';

export default {
  name: 'App',
  mixins: [windowResizeMixin, productEventsMixin, featureFlagMixin],
  components: {
    // load from me-modules artist navbar & footer
    // NavBar,
    ShinySvgGradient: () => import('@motionelements/core/src/components/product/ShinySvgGradient.vue'),
    FlashNotifications: () => import('@motionelements/core/src/components/ui/notifications/BaseFlashNotifications.vue'),
    ToastNotifications: () => import('@motionelements/core/src/components/ui/notifications/BaseToastNotifications.vue'),
    RootModal: () => import(/* webpackPrefetch: true */ '@motionelements/core/src/components/TheRootModal.vue'),
    Blocker: () => import(/* webpackPrefetch: true */ '@motionelements/core/src/components/ui/Blocker.vue'),
  },
  data() {
    return {
      transitionName: 'page-no-fade',
    };
  },
  computed: {
    ...mapState({
      showBlocker: state => state.blocker.show,
      blockerMessage: state => state.blocker.message,
      isLoggedIn: state => state.user.isLoggedIn,
    }),
  },
  beforeCreate() {
    sessionStorage.removeItem('me:vuex:account');
    //
    bootstrapApp(this);
  },
  created: function () {
    if (process.env.VUE_APP_PRERENDER === 'false') {
      this.transitionName = 'page-fade';
    }
  },
  mounted() {
    if (!this.isLoggedIn) {
      this.$store.dispatch('modal/showSignUp');
    }

    // GTM behavior detect
    // this.$root.$on('updateGoogleTagManager', this.updateGoogleTagManager);

    // this.$root.$on('filterSimilar', this.filterSimilar);
  },
  methods: {
    // updateGoogleTagManager(info) {
    //   console.log('updateGoogleTagManager created : ', info);
    //
    //   let memberType = 'member';
    //   if (info.artist) {
    //     memberType = 'artist';
    //   }
    //   if (info.admin) {
    //     memberType = 'admin';
    //   }
    //   if (info.reseller) {
    //     memberType = 'reseller';
    //   }
    //
    //   this.$gtm.trackEvent({
    //     event: 'vue_root_created',
    //     userId: info.id,
    //     username: info.username,
    //     firstName: info.first_name,
    //     lastName: info.last_name,
    //     fullName: info.full_name,
    //     email: info.email,
    //     memberType: memberType,
    //     industry: info.industry,
    //     language: info.language,
    //     countryCode: info.country,
    //     jobFunction: info.job_function,
    //   });
    // },
  },
  // beforeDestroy() {
  //   this.$root.$off('updateGoogleTagManager', this.updateGoogleTagManager);
  //
  //   // this.$root.$off('filterSimilar', this.filterSimilar);
  // },
};
